/* assets/giddy-header-state.js */
/* Drives the cart-state-aware sticky header behavior:
   - On every page, detect cart state on load and toggle body.giddy-cart-has-items.
   - When user adds to cart anywhere on the site, open the cart drawer (the "notification")
     and update the body class.
   - When cart is empty: header auto-hides on scroll-down, shows on scroll-up.
   - When cart has items: header stays permanently sticky at top, tier strip shifts below it. */
(function () {
  'use strict';

  var body = document.body;
  if (!body) return;

  var AUTO_OPEN_THRESHOLD = 18;
  var lastKnownCount = null;
  var autoOpenedAtThreshold = false;

  function syncFromCart(cart) {
    if (!cart) return;
    var count = cart.item_count || 0;
    var hasItems = count > 0;
    body.classList.toggle('giddy-cart-has-items', hasItems);

    // Update ONLY the cart icon's bubble — scoped to #cart-icon-bubble so
    // we don't accidentally clobber the wishlist icon's bubble (which
    // shares the .cart-count-bubble class for styling consistency).
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble').forEach(function (bubble) {
      var span = bubble.querySelector('span[aria-hidden="true"]');
      if (span) span.textContent = count;
      bubble.style.visibility = hasItems ? 'visible' : 'hidden';
    });

    // Auto-open drawer when count CROSSES the 18-item threshold upward.
    // Only fires once per "session at threshold" — won't re-fire if they hover at >=18,
    // and re-arms once they drop below 18 again.
    if (lastKnownCount !== null) {
      if (count >= AUTO_OPEN_THRESHOLD && lastKnownCount < AUTO_OPEN_THRESHOLD && !autoOpenedAtThreshold) {
        autoOpenedAtThreshold = true;
        document.dispatchEvent(new Event('giddy:cart:open'));
      } else if (count < AUTO_OPEN_THRESHOLD) {
        autoOpenedAtThreshold = false;
      }
    }
    lastKnownCount = count;
  }

  function fetchCartState() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(syncFromCart)
      .catch(function () {});
  }

  // Initial sync on page load
  fetchCartState();

  // Intercept fetch to detect cart mutations from anywhere on the site
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var promise = origFetch.apply(this, arguments);
    var url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');
    var isAdd = url.indexOf('/cart/add') !== -1;
    var isChange = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1;

    if (isAdd || isChange) {
      promise.then(function (response) {
        if (!response || !response.ok) return;
        // Re-sync cart state after a short delay so Shopify has settled.
        // The drawer only auto-opens when the 18-item threshold is crossed
        // (handled inside syncFromCart). Otherwise we just nudge the cart
        // icon via the shake animation tied to body.giddy-cart-has-items.
        setTimeout(fetchCartState, 80);
      }).catch(function () {});
    }
    return promise;
  };

  // Track the header height so the tier strip knows how far to offset.
  // Re-measure aggressively because Fraunces and the logo can shift height
  // after the first paint, and we don't want any visible seam.
  var header = document.querySelector('.header-wrapper');
  function updateHeaderHeight() {
    if (!header) return;
    var h = header.offsetHeight;
    if (h > 0) body.style.setProperty('--giddy-header-height', h + 'px');
  }
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('load', updateHeaderHeight);
  // Re-measure after fonts settle (Fraunces can affect height once it loads)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderHeight);
  }
  // Safety-net re-measurements at staggered intervals so late layout shifts
  // (logo image swap, late-loading nav menus) don't leave a stale value.
  setTimeout(updateHeaderHeight, 100);
  setTimeout(updateHeaderHeight, 500);
  setTimeout(updateHeaderHeight, 1500);
  // Continuous tracking: ResizeObserver fires whenever the header's own
  // dimensions change (e.g. announcement bar collapse, mobile menu toggle).
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(updateHeaderHeight);
    ro.observe(header);
  }

  // Track whether the user has scrolled past the announcement bar.
  // When they have, the menu can safely fix itself to top:0. While the
  // announcement bar is still visible, the menu stays in normal flow below it.
  function checkPastAnnouncement() {
    var announce = document.querySelector('.giddy-ann') || document.querySelector('.utility-bar');
    if (!announce) {
      body.classList.add('giddy-past-announcement');
      return;
    }
    var rect = announce.getBoundingClientRect();
    if (rect.bottom <= 0) {
      body.classList.add('giddy-past-announcement');
    } else {
      body.classList.remove('giddy-past-announcement');
    }
  }

  var pastTicking = false;
  window.addEventListener('scroll', function () {
    if (!pastTicking) {
      requestAnimationFrame(function () {
        checkPastAnnouncement();
        pastTicking = false;
      });
      pastTicking = true;
    }
  }, { passive: true });
  checkPastAnnouncement();
  // Re-check when the announcement bar's height changes (font swaps, rotation)
  if (window.ResizeObserver) {
    var announceEl = document.querySelector('.giddy-ann') || document.querySelector('.utility-bar');
    if (announceEl) {
      new ResizeObserver(checkPastAnnouncement).observe(announceEl);
    }
  }
})();
